//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import RequestRejectReopenDialog from './RequestRejectReopenDialog.vue'

export default {
  components: {
    RequestRejectReopenDialog: RequestRejectReopenDialog
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    hasFinishReportCreatedOrEditing: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dialogOpened: false
    }
  },
  computed: {
    hasEditAccess: function () {
      return !!this.requestRoles.hasEditAccess
    },
    canToggleRejectReopen: function () {
      if (!this.hasEditAccess) {
        return false
      }
      return this.request.rejectReopen || !this.hasFinishReportCreatedOrEditing
    },
    rejectReopenBreakageRoadsName: function () {
      return this.request.rejectReopenBreakageRoads ? this.request.rejectReopenBreakageRoads.name : null
    },
    rejectReopenEquipmentStatusRoadsName: function () {
      return this.request.rejectReopenEquipmentStatusRoads ? this.request.rejectReopenEquipmentStatusRoads.name : null
    }
  },
  methods: {
    onToggleRejectReopen: function (value) {
      if (value) {
        if (this.hasFinishReportCreatedOrEditing) {
          return
        }
        this.dialogOpened = true
      } else {
        this.confirmCancelRejectReopen()
      }
    },
    confirmCancelRejectReopen: async function () {
      const confirmed = await this.$d_askConfirmation(
        'Снять режим отказа ВИС в возвращении заявки в работу?',
        'Введённые причина, тип неисправности и состояние оборудования будут очищены.'
      )

      if (!confirmed) {
        return
      }

      this.$set(this.request, 'rejectReopen', false)
      this.$set(this.request, 'rejectReopenDescription', null)
      this.$set(this.request, 'rejectReopenBreakageRoads', null)
      this.$set(this.request, 'rejectReopenEquipmentStatusRoads', null)
    },
    onConfirmRejectReopen: function (rejectReopenProps) {
      this.$set(this.request, 'rejectReopenDescription', rejectReopenProps.rejectReopenDescription)
      this.$set(this.request, 'rejectReopenBreakageRoads', rejectReopenProps.rejectReopenBreakageRoads)
      this.$set(this.request, 'rejectReopenEquipmentStatusRoads', rejectReopenProps.rejectReopenEquipmentStatusRoads)
      this.$set(this.request, 'rejectReopen', true)
      this.dialogOpened = false
    }
  }
}

